<template lang="pug">
div.login.abs-fit
  div.login-header.flex.align-center.justify-center
    div.logo
    div.h1 {{ appName }}
    //- div.h4.mt2 号安全、高效、节能。定制功能，满足多种应用场景。
  div.login-body
    div.login-box-box
      div.login-box(@keypress.enter="handleLogin" v-show="!slideVerifyShow")
        div.login-box-header
          div.h1.center 用户登录
        div.login-box-form
          a-form-model(:rules="rules" :model="model" ref="form")
            a-form-model-item(prop="username")
              a-input(size="large" placeholder="账号" v-model="model.username" allow-clear)
                a-icon(slot="prefix" type="user")
            a-form-model-item(prop="password")
              a-input-password(type="password" size="large" placeholder="密码" v-model="model.password" allow-clear)
                a-icon(slot="prefix" type="key")
        div.login-box-foolter
          div.clearfix
            a-button(type="primary" shape="round" size="large" block @click="handleLogin" :loading="loading" ) 登 录
          div.clearfix
            div.left.mt1.ml3() 
              a-checkbox(v-model="model.remberMe") 
                app-link-btn 记住我
            app-link-btn.right.mt1.mr3(to="/register") 新用户注册
      div.login-box(v-show="slideVerifyShow")
        a-spin(:spinning="slideVerifyLoading")
          div.slide-verify-box
            div.pt1(style="color: #999;") 拖动下方滑块完成拼图
            SlideVerify(
            ref="slideblock"
            :l="42"
            :r="10"
            :w="310"
            :h="155"
            :imgs="slideVerifyImgs"
            @success="onSuccess"
            @again="onAgain"
            @fail="onFail"
            @refresh="onRefresh"
            @fulfilled="onFulfilled"
            slider-text="向右滑动")
            div.mt2.mb2.pb1
              a-button(type="danger" block @click="slideVerifyShow = false;") 关闭
    div.chrome-link 
      //- span.p1 友情链接: 
      //-   a.p1(href="https://www.google.cn/intl/zh-CN/chrome/" target="_blank") 深农集团官网
      span.p1 推荐使用: 谷歌浏览器
        a.p1(href="https://www.google.cn/intl/zh-CN/chrome/" target="_blank") 下载谷歌浏览器
  //- div.qrcode-box
    div.qrcode-item
      img(:src="qrcode1")
      span 专家小程序
  //- div.login-footer
    div.cneter
      span.p1 CopyRight2003-2020 深圳市农产品集团股份有限公司版权所有
    div.cneter.mt1
      span.p1 技术支持: 
        a(href="http://www.guhecloud.com/" target="_blank") 成都古河云科技有限公司 
</template>

<script>
import Vue from 'vue';
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);

import allJpg from './images';

import {
  loginForPassword,
  getProjectCode,
  getToken,
} from '@/services/AccountService';
import qs from 'qs';
export default {
  data() {
    return {
      // qrcode: require('@/assets/login/qrcode.png'),
      qrcode1: require('@/assets/login/qrcode.jpg'),
      appName: window.config.appName,
      rules: {
        username: [{ required: true, message: '请填写用户名。' }],
        password: [{ required: true, message: '请填写密码。' }],
      },
      model: {
        username: null,
        password: null,
        code: null,
        remberMe: true,
      },
      loading: false,
      //
      slideVerifyImgs: allJpg,
      slideVerifyShow: false,
      slideVerifyLoading: false,
      slideVerifyMsg: '',
    };
  },
  computed: {
    cb() {
      // 总部的callback
      const { cb } = this.$route.query;
      return cb ? decodeURIComponent(cb) : null;
    },
    projectCode() {
      // 园区的projectCode
      const { projectCode } = this.$route.query;
      return projectCode;
    },
    callback() {
      // 园区的callback
      const { callback } = this.$route.query;
      return callback ? decodeURIComponent(callback) : null;
    },
  },
  methods: {
    async handleLogin() {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        // this.slideVerifyLoading = true;
        this.slideVerifyShow = true;
      }
    },
    onSuccess() {
      this.slideVerifyLoading = true;
      this.$restful(`GET:/sys/public/users/captcha-code`, {
        username: this.model.username,
      })
        .then(({ code }) => {
          // this.$message.success('校验通过!');
          this.slideVerifyMsg = '验证通过';
          this.slideVerifyShow = false;
          this.login(code);
        })
        .catch(() => {
          // this.$refs.slideblock.reset();
        })
        .finally(() => {
          this.$refs.slideblock.reset();
          this.slideVerifyLoading = false;
        });
    },
    onAgain() {
      // console.log('检测到非人为操作的哦！');
      this.slideVerifyMsg = 'try again';
      // 刷新
      this.$refs.slideblock.reset();
    },
    onFail() {
      this.$message.error('校验失败!');
      this.slideVerifyLoading = true;
      this.slideVerifyMsg = '验证失败';
      // console.log('onFail');
    },
    onRefresh() {
      this.slideVerifyLoading = true;
      this.slideVerifyMsg = '';
      console.log('onRefresh');
    },
    onFulfilled() {
      setTimeout(() => {
        this.slideVerifyLoading = false;
      }, 400);
      console.log('刷新成功啦！');
    },
    async login(code) {
      const model = { ...this.model, code };
      try {
        this.loading = true;
        await loginForPassword(model);
        this.$message.success('登陆成功!');
        this.handleLoginSuccess();
      } catch (error) {
        if (error.response.status === 401) {
          const errorMessage = error.response?.data?.error_description;
          this.$message.error(errorMessage || '用户名或密码不正确。');
          this.loading = false;
        }
      } finally {
        this.loading = false;
      }
    },
    async handleLoginSuccess() {
      const token = await getToken();
      const projects = await this.$restful('GET:/sys/context/user-projects');
      if (projects.length === 1) {
        // 只有一个项目直接跳!
        // this.handClickProject(projects[0]);
        const params = {
          ...token,
          code: projects[0].code,
        };
        this.$router.replace({ path: this.cb || '/', query: params });
      } else {
        this.$router.replace({ path: '/projects/select' });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  height: 100%;
  overflow: hidden;
  background-color: #ffffff;
  // background-image: url(../../assets/login/bg.png),
  //   url(../../assets/login/fg-bottom.png);
  // background-position: top left, bottom center;
  // background-repeat: repeat, repeat-x;
  // background-size: auto auto, auto 15vh;
  background-image: url(../../assets/login/bg.png);
  background-position: -15px -15px;
  background-repeat: repeat;
  background-size: auto auto;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  &-header {
    position: absolute;
    top: calc(25% - 150px);
    left: 0;
    right: 0;
    text-align: left;
    color: rgba(0, 0, 0, 0.85);
    // flex: 1;
    box-sizing: border-box;
    .logo {
      height: 50px;
      width: 60px;
      // background-image: url(../../assets/login/dy_logo.png);
      background-image: url(../../assets/login/logo.jpg);
      background-position: left center;
      background-repeat: no-repeat;
      background-size: auto 100%;
    }
    .h1 {
      font-size: 36px;
      font-weight: 600;
    }
  }

  &-body {
    position: absolute;
    top: calc(50% - 250px);
    left: 0;
    right: 0;
    height: 500px;
    // background-color: aqua;
    // background: url(../../assets/login/fbg.png) right no-repeat;
    // background-size: cover;
    background-color: rgb(64, 157, 255);
    // background-image: url(../../assets/login/dyjz_logo.png),
    //   url(../../assets/login/guofeng_bg.png);
    // background-position: 10% 10%, right bottom;
    // background-repeat: no-repeat, no-repeat;
    // background-size: auto 50%, 100% auto;
    background-image: url(../../assets/login/guofeng_bg.png);
    background-position: right bottom;
    background-repeat: no-repeat;
    background-size: 100% auto;
    // flex: auto;
    .login-box-box {
      width: 500px;
      height: 500px;
      margin: 0 auto;
      background-color: #fff;
      overflow: hidden;
      // transform: rotateZ(45deg);
      padding: 50px;
      box-shadow: 0 0 5px 1px #efefef;
      // opacity: 0.95;
    }
    .login-box {
      width: 100%;
      height: 100%;
      overflow: hidden;
      // transform: rotateZ(-45deg);
      .ant-input {
        border-top: 0px;
        border-right: 0px;
        border-left: 0px;
      }
    }
    .login-box-header {
      .h1 {
        font-size: 26px;
        font-weight: bold;
        margin: 50px 0;
      }
    }
    .login-box-foolter {
      // padding: 20px 40px;
      padding: 1px 40px;
    }
    .chrome-link {
      position: absolute;
      // bottom: -24px;
      // right: 2rem;
      top: 508px;
      left: 50%;
      transform: translateX(-50%);
    }
    .slide-verify-box {
      margin: 52px 30px;
      padding: 0 15px;
      box-shadow: 0 0 10px #cccccc;
      border: 1px solid #cccccc;
      .slide-verify {
        margin: auto;
      }
    }
  }
  .qrcode-box {
    position: absolute;
    right: 0;
    bottom: 0;
    margin: 2em;
    display: flex;
    .qrcode-item {
      display: flex;
      padding: 1rem 1rem 0 1rem;
      flex-direction: column;
      align-items: center;
      background-color: #fff;
      box-shadow: 0 0 5px 1px #dfdfdf;
      z-index: 2;
      cursor: pointer;
      &:hover {
        box-shadow: 0 0 5px 1px #bfbfbf;
        img {
          width: 250px;
          height: 250px;
        }
        span {
          padding-bottom: 1rem;
        }
      }
      & + .qrcode-item {
        margin-left: 1rem;
      }
      img {
        width: 100px;
        height: 100px;
      }
      span {
        font-size: 12px;
        font-weight: bold;
        // padding-top: 1rem;
      }
    }
  }
  &-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 1em auto;
    text-align: center;
  }
}
</style>
<style lang="less">
// 清除默认样式, 清除自动填充样式
.login-box {
  .ant-input {
    border-radius: 0 !important;
    border-top: 0px !important;
    border-right: 0px !important;
    border-left: 0px !important;
    box-shadow: none !important;
  }
  input:-internal-autofill-previewed,
  input:-internal-autofill-selected {
    background-color: white !important;
    background-image: none !important;
    color: rgb(0, 0, 0) !important;
    box-shadow: inset 0 0 0 1000px white !important;
  }
  input:-webkit-autofill {
    box-shadow: 0 0 0px 1000px white inset !important;
  }
  input:-webkit-autofill:focus {
    box-shadow: 0 0 0px 1000px white inset !important;
  }
}
.slide-verify-box {
  canvas {
    background-color: #efefef;
    &.slide-verify-block {
      background-color: transparent;
    }
  }
}
</style>
